import React, { useEffect } from "react";
import { Text } from "@zorni/components-lib";
import { PARTNER_TYPE } from "../../../common/model/enum";
import { useTranslation } from "react-i18next";
import { SelectMenu } from "@zorni/components-lib";

const PartnerType = (props) => {
  const { t } = useTranslation();

  const getPartenrType = (partnerType) => {
    if (partnerType && Array.isArray(partnerType)) {
      const translateType = (type) => {
        switch (type) {
          case PARTNER_TYPE.TRAVEL_SERVICE:
            return t("manageEstablishment.establishment.partnerType.travel");
          case PARTNER_TYPE.ACCOMMODATION_SERVICE:
            return t(
              "manageEstablishment.establishment.partnerType.accomodation"
            );
          default:
            return t("commons.notSpecified");
        }
      };

      switch (partnerType.length) {
        case 1:
          return translateType(partnerType[0]);
        case 2:
          return `${translateType(partnerType[0])} and ${translateType(
            partnerType[1]
          )}`;
        default:
          return t("commons.notSpecified");
      }
    } else {
      return t("commons.notSpecified");
    }
  };

  const partnerTypeList = [
    {
      value: PARTNER_TYPE.TRAVEL_SERVICE,
      text: t("manageEstablishment.establishment.partnerType.travel"),
    },
    {
      value: PARTNER_TYPE.ACCOMMODATION_SERVICE,
      text: t("manageEstablishment.establishment.partnerType.accomodation"),
    },
  ];

  useEffect(() => {
    if (props.isEditMode && !props.partnerType) {
      props.setPartnerType(partnerTypeList[0].value);
    }
  }, [props.isEditMode, partnerTypeList, props.setPartnerType]);

  if (props.isEditMode) {
    return (
      <SelectMenu t={t}
        data-testid="partnerTypeSelect"
        options={partnerTypeList}
        floatingLabel={props.floatingLabel}
        inputSize={props.inputSize || "medium"}
        label={props.label}
        placeholder={
          props.placeholder ||
          t("manageEstablishment.establishment.partnerType.label")
        }
        value={props.partnerType}
        onChange={(value, option) => props.setPartnerType(option.value)}
      />
    );
  } else {
    return <Text type="text">{getPartenrType(props.partnerType)}</Text>;
  }
};

export default PartnerType;
